<div role="tabpanel" class="tab-pane checklist portfolio-tab-pane {{#if first}}active{{/if}}" id="{{key}}_pane">
  <div class="resource-items"></div>
</div>